// extracted by mini-css-extract-plugin
export default {"modalContent":"Payment_modalContent__Z1fGt"};